export default __webpack_public_path__ + "static/media/37-PurpleHaze.7cc3a43e.jpeg";